export default __webpack_public_path__ + "static/media/headphones.759080bb.svg";